<!-- 
    <div class="property-wrap max-width-100">
        <a [href]="'/view-property/' + propertyData.id + '/' + shared.generateUrlSlug(propertyData.property_name)" class="img img-property" [style.backgroundImage]="propertyImage ? 'url(' + shared.getImageURL(propertyImage) + ')' : 'url(../../assets/images/no-image.jpg)'">
            <p class="price"><span class="orig-price">{{shared.formatPriceAED(propertyData.price)}}</span></p>
        </a>
        <div class="text" [ngClass]="pClass ? pClass : ''">
            <p class="m-0">
                <a class="property-title" [href]="'/view-property/' + propertyData.id + '/' + shared.generateUrlSlug(propertyData.property_name)"> {{propertyData.property_name}}</a>
            </p>
            <span class="location d-flex">
                <span class="textflow-cut"> {{propertyData && propertyData.PropertyToMasterLandmarkData &&
                    propertyData.PropertyToMasterLandmarkData.landmark_name ?
                    propertyData.PropertyToMasterLandmarkData.landmark_name + ',' : ''}}
                    {{propertyData &&
                    propertyData.PropertyToMasterCityData && propertyData.PropertyToMasterCityData.city_name
                    ?
                    propertyData.PropertyToMasterCityData.city_name : ''}}</span> 
                <span class="sale">{{propertyData.selling_type == 1 ? 'Sell' : 'Rent'}}</span>
            </span>
            <ul class="property_list mt-3 mb-0">
                <li *ngIf="propertyData && propertyData.no_of_bedrooms && propertyData.no_of_bedrooms != '0'"><span class="flaticon-bed"></span>{{propertyData.no_of_bedrooms}}</li>
                <li *ngIf="propertyData && propertyData.no_of_bathrooms && propertyData.no_of_bathrooms != '0'"><span class="flaticon-bathtub"></span>{{propertyData.no_of_bathrooms}}</li>
                <li *ngIf="propertyData">
                    <ng-container *ngIf="propertyData.plot_area && propertyData.plot_area != '0'">
                        {{propertyData.plot_area}} sqft
                    </ng-container>
                    <ng-container *ngIf="!(propertyData.plot_area && propertyData.plot_area != '0')">
                        &nbsp;
                    </ng-container>
                </li>
            </ul>
        </div>
    </div> -->

<div class="property-card compact-offer-card">
    
    <a 
      [href]="'/view-property/' + propertyData.id + '/' + shared.generateUrlSlug(propertyData.property_name)" 
      class="card-image-container compact-image-container">
      
      <div 
        class="compact-image"
        [style.backgroundImage]="propertyImage ? 'url(' + shared.getImageURL(propertyImage) + ')' : 'url(../../assets/images/no-image.jpg)'">
      
      </div>
    </a>

    <div class="card-details compact-details">
        
        <h3 class="property-title">
            <a [href]="'/view-property/' + propertyData.id + '/' + shared.generateUrlSlug(propertyData.property_name)">
                {{propertyData.property_name}}
            </a>
            <i class="fas fa-check-circle verified-icon"></i>
        </h3>
        
        <p class="location-text">
      {{propertyData.PropertyToMasterLandmarkData?.landmark_name}}
      {{propertyData.PropertyToMasterCityData?.city_name}}
    </p>
    <p class="price-text">{{shared.formatPriceAED(propertyData.price)}}</p>
<div class="property-features">
  <div class="feature-item" *ngIf="propertyData.no_of_bedrooms != '0'">
    <i class="fas fa-bed"></i> <span>{{propertyData.no_of_bedrooms}}</span>
    <span class="feature-label">Bedrooms</span>
  </div>
  <div class="feature-item" *ngIf="propertyData.no_of_bathrooms != '0'">
    <i class="fas fa-bath"></i> <span>{{propertyData.no_of_bathrooms}}</span>
    <span class="feature-label">Bathrooms</span>
  </div>
  <div class="feature-item" *ngIf="propertyData.plot_area != '0'">
    <i class="fas fa-ruler-combined"></i> <span>{{propertyData.plot_area}}</span>
    <span class="feature-label">Total area</span>
  </div>
</div>

        
    </div>
</div>

